import '@/styles/dropZoneOverlay.css';

export interface DropZoneOverlayProps {
  /** Текст на бейдже по центру */
  label?: string;
  className?: string;
}

/** Визуальный слой «перетащите файлы»; без событий — DnD вешают на родителя. */
export function DropZoneOverlay({ label = 'Перетащите сюда', className = '' }: DropZoneOverlayProps) {
  return (
    <div className={className ? `drop-zone-overlay ${className}` : 'drop-zone-overlay'} aria-hidden>
      <span className="drop-zone-overlay__label">{label}</span>
    </div>
  );
}
